import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import OurPractice from './pages/OurPractice';
import MeetTheDoctor from './pages/MeetTheDoctor';
import Services from './pages/Services';
import TraditionalPrimaryCare from './pages/TraditionalPrimaryCare';
import MDVIPServices from './pages/MDVIPServices';
import WellnessServices from './pages/WellnessServices';
import Purepell from './pages/Purepell';
import Fullscript from './pages/Fullscript';
import Mindfulness from './pages/Mindfulness';
import AestheticServices from './pages/AestheticServices';
import AnnualWellnessTesting from './pages/AnnualWellnessTesting';
import Contact from './pages/Contact';
import './App.css';

function AnimatedRoutes() {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/our-practice" element={<OurPractice />} />
        <Route path="/meet-the-doctor" element={<MeetTheDoctor />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/traditional-primary-care" element={<TraditionalPrimaryCare />} />
        <Route path="/services/mdvip-services" element={<MDVIPServices />} />
        <Route path="/services/mdvip-services/annual-wellness-testing" element={<AnnualWellnessTesting />} />
        <Route path="/services/wellness-services" element={<WellnessServices />} />
        <Route path="/services/wellness-services/purepell" element={<Purepell />} />
        <Route path="/services/wellness-services/fullscript" element={<Fullscript />} />
        <Route path="/services/wellness-services/mindfulness" element={<Mindfulness />} />
        <Route path="/services/wellness-services/aesthetic-services" element={<AestheticServices />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main>
          <AnimatedRoutes />
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
